module.exports = __webpack_public_path__ + "img/rupsagor.eafbc2cc.png";